import React, { useEffect } from "react";
import { Form, notification } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { RootState } from "../../../store";
import { usePostPaymentInsertMutation, usePostPaymentMutation, usePrePaymentInsertMutation, usePostInfintechPaymentMutation, useGetPaymentConfigMutation } from "../../../state/globalApi";
import { LookupRequest } from "../../../models/lookup-request";
import { buildPaymentConfigRequest, paymentRequest, session } from "../../../state/connect-api";
import axios from "axios";
import submitEFileRequest from "../useEFile";
import getConfigs from "../../../GetConfigs";

interface StateType {
  state: {
    fromPage?: string;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const useEFilePayment = () => {
  const { casePayment: paymentData, activeCaseNumber } = useSelector((state: RootState) => state.global);
  const [res, setRes] = useState<any>();
  const history = useNavigate();
  const configurations = getConfigs([
    "activePayProcessor",
    "authorizeSandbox"
  ]);
  const [postPay, { data, isLoading: paymentTokenLoading }] = usePostPaymentMutation();
  const [token, setToken] = useState<string>();
  const [prePaymentInsert, { data: preInsertData, isLoading: preInsertLoading }] = usePrePaymentInsertMutation();
  const [postPaymentInsert, { data: postInsertData, isLoading: postInsertLoading }] = usePostPaymentInsertMutation();
  const [postPaymentInfintech, { data: postInfintechData, isLoading: infintechLoading }] = usePostInfintechPaymentMutation();
  const [getConfig] = useGetPaymentConfigMutation();
  const [transactionId, setTransactionId] = useState<string>();
  const [amount, setAmount] = useState<number>();
  const [amountData, setAmountData] = useState<boolean>(true);
  const authorizeSandbox = configurations.authorizeSandbox == "true";
  useEffect(() => {
    if (transactionId && amount) {
      handleMakePayment(amount);
    }
  }, [transactionId]);

  const handleContinue = async (amount: number) => {
    setAmount(amount);
    setAmountData(!amountData);
    handlePrePayment(amount);
  };

  const handleMakePayment = async (amountDue) => {
    if (!amountDue) {
      return submitEFileRequest();
    }
    if (transactionId == undefined) {
      handlePrePayment(amountDue);
      return;
    }
    switch (configurations.activePayProcessor) {
      case "bridge":
        return bridgePayment(amountDue);
      case "infintech":
        return infintechPayment(amountDue);
      case "paypal":
        return payPalPayment(amountDue);
      case "authorize":
        return authorizePayment(amountDue);
      default:
        console.log("payment not configured");
    }
  };
  const bridgePayment = async (amountDue) => {
    const bridgeConfigRequestItems = buildPaymentConfigRequest("bridge");
    const configRequest = await getConfig(bridgeConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});

    const form = document.createElement("form");
    form.method = "POST";
    form.action = configObject.payProcessorPayUrl;
    form.target = "_blank";
    const values = {
      PayerID: activeCaseNumber,
      AmountOwed: amountDue,
      ClientID: configObject.ClientID,
      TransactionReference: transactionId,
      SessionID: session,
      payPostBack: configObject.payPostBack,
      payProcessorAcctID: configObject.payProcessorAcctID,
      payProcessorKey: configObject.payProcessorKey,
      MerchantID: configObject.TRCRMerchantId

    };
    Object.keys(values).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = values[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const infintechPayment = async (amountDue) => {
    const infintechOrderId = `${activeCaseNumber}-${transactionId}-${session}`;
    const JsonBody = {
      clientId: "", //infintechConfig.payProcessorClientID,
      orderId: infintechOrderId,
      preSharedKey: "", //infintechConfig.payProcessorPreSharedKey,
      redirectUrl: "", //"http://web1.civicacmi.com/Court/Default.aspx",
      principalAmount: amountDue,
      postUrl: "", //infintechConfig.postUrl,
      cancelUrl: "", //infintechConfig.cancelUrl,
      emailReceipt: "", //infintechConfig.emailReceipt,
      emailForm: "", //infintechConfig.emailForm,
      stationId: "", //`${infintechConfig.appid}-${infintechConfig.client_id}`,
      clerkId: null,
      cancelTimeout: "99999",
      items: [
        {
          itemId: "CT",
          name: `${activeCaseNumber} Court Payment`,
          quantity: "1",
          amount: amount
        }
      ]
    };

    const response = await postPaymentInfintech(JsonBody).unwrap();
    window.location.href = response.url;

    return response;
  };

  const payPalPayment = async (amountDue) => {
    const payPalConfigRequestItems = buildPaymentConfigRequest("payPal");
    const configRequest = await getConfig(payPalConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});
    const formValues = {
      LOGIN: configObject.payProcessorAcctID,
      PARTNER: configObject.partner,
      TYPE: configObject.type,
      AMOUNT: amountDue,
      user1: activeCaseNumber,
      user5: configObject.user5,
      user7: configObject.applicationId,
      user6: configObject.siteId,
      user8: transactionId,
      user9: session,
      user10: null
    };

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://pilot-payflowlink.paypal.com/";
    form.target = "_blank";
    Object.keys(formValues).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formValues[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const authorizePayment = async (amountDue) => {
    const body = {
      getHostedPaymentPageRequest: {
        merchantAuthentication: {
          name: "",
          transactionKey: ""
        },
        transactionRequest: {
          transactionType: "authCaptureTransaction",
          amount: `${amountDue}`,
          billTo: {
            firstName: "",
            lastName: "",
            company: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            country: "US"
          }
        },
        hostedPaymentSettings: {
          setting: [
            {
              settingName: "hostedPaymentReturnOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentButtonOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentStyleOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentPaymentOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentSecurityOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentShippingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentBillingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentCustomerOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentOrderOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentIFrameCommunicatorUrl",
              settingValue: ""
            }
          ]
        }
      }
    };
    const response = await postPay(body).unwrap();
    setRes(response.token);
    return response;
  };

  const handlePrePayment = async (amountDue) => {
    setAmount(amountDue);
    const lookupRequest: LookupRequest = paymentRequest(activeCaseNumber, paymentData?.MAIN[0]?.PaymentType, `${amountDue}`);
    const prepaymentRequest = await prePaymentInsert(lookupRequest).unwrap();
    setTransactionId(preInsertData?.MAIN[0]?.PAY_TRANSID);
    setTransactionId(prepaymentRequest?.MAIN[0]?.PAY_TRANSID);
    return transactionId;
  };

  const handlePostPayment = async (responseData) => {
    const remoteAddress = await axios.get("https://geolocation-db.com/json/");
    const lookupRequest: LookupRequest = paymentRequest(transactionId, activeCaseNumber, responseData?.totalAmount, "", responseData?.dateTime, remoteAddress?.data.IPv4);
    const postpay = await postPaymentInsert(lookupRequest).unwrap();
  };

  return {
    paymentData,
    handleMakePayment,
    token,
    paymentTokenLoading,
    res,
    authorizeSandbox,
    preInsertLoading,
    handleContinue
  };
};

export default useEFilePayment;
